@if (
  allowedAndEnabledFeedbackOptions.includes('favourite') ||
  allowedAndEnabledFeedbackOptions.includes('status') ||
  allowedAndEnabledFeedbackOptions.includes('color_label')
) {
  <app-context-menu [options]="{ width: '240px', noSpacing: true }">
    <button
      appButton
      name="filter"
      location="view-filter"
      [color]="theme.cover.design && mode === 'layout' ? 'blur' : 'default-opacity'"
      shape="round"
      height="1"
      size="1"
      [hasIcon]="true"
      weight="bold"
      contextButton
    >
      <app-svg src="/assets/icons/filter.svg"></app-svg>
      <span>Filter</span>
      @if (hasFilters) {
        <span class="changes-dot"></span>
      }
    </button>
    <div class="button-menu" contextContent>
      @if (allowedAndEnabledFeedbackOptions.includes('favourite')) {
        <app-radio-button
          [checked]="allFilters.is_liked === true"
          (click)="toggleFilter('is_liked', true)"
          [hasIcon]="true"
          location="view-filter"
        >
          <app-svg src="/assets/icons/heart-filled.svg" color="warn"></app-svg>
          <span class="standard-dark-text">Your Favorites</span>
        </app-radio-button>
        <app-radio-button
          [checked]="allFilters.is_liked === false"
          (click)="toggleFilter('is_liked', false)"
          [hasIcon]="true"
          location="view-filter"
        >
          <app-svg src="/assets/icons/heart-empty.svg" color="grey-50"></app-svg>
          <span class="standard-dark-text">Not Favorited</span>
        </app-radio-button>
      }
      @if (allowedAndEnabledFeedbackOptions.includes('status')) {
        @if (allowedAndEnabledFeedbackOptions.includes('favourite')) {
          <div class="divider"></div>
        }
        @for (status of gallery.enabled_asset_statuses | assetStatusOrder: true; track status) {
          <app-radio-button
            [checked]="allFilters.status === status"
            (click)="toggleFilter('status', status)"
            [hasIcon]="true"
            location="view-filter"
          >
            <app-svg
              [src]="'/assets/icons/' + (status | assetStatusIcon) + '.svg'"
              [attr.color]="(status | assetStatusColor) || 'grey-50'"
            ></app-svg>
            <span class="standard-dark-text">{{ status | assetStatusName }}</span>
          </app-radio-button>
        }
      }
      @if (allowedAndEnabledFeedbackOptions.includes('color_label')) {
        @if (
          allowedAndEnabledFeedbackOptions.includes('favourite') || allowedAndEnabledFeedbackOptions.includes('status')
        ) {
          <div class="divider"></div>
        }
        @for (label of colorLabels; track label) {
          <app-radio-button
            [checked]="allFilters.color_label[label.color]"
            (click)="toggleFilter('color_label', label.color)"
            [hasIcon]="true"
            location="view-filter"
          >
            <app-svg src="/assets/icons/color-label-filled.svg" [attr.color]="label.color"></app-svg>
            <span class="standard-dark-text">{{ label.name }}</span>
          </app-radio-button>
        }
      }
    </div>
  </app-context-menu>
}
